export default "__VITE_ASSET__CAJ9y7u9__"